import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetJackpotList = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_JACKPOT
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetJackpotListAction(data.data));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetJackpotList as SetGetJackpotList
}